import { MachineSWUpdateData } from '@/models/MachineSWUpdateData';
import { UISWUpdateData } from '@/models/UISWUpdateData';
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ name: 'update' })
export default class UpdateStore extends VuexModule {
  machineUpdates: Array<MachineSWUpdateData> = [];
  currentMachineUpdate: MachineSWUpdateData | null = null;
  deferredUpdates: Array<string> = [];
  lastUIUpdate: UISWUpdateData | null = null;

  get currentMachineMandatory(): boolean {
    return this.currentMachineUpdate?.available_update_status == 3;
  }

  @Mutation
  setlastUIUpdate(update: UISWUpdateData | null) {
    this.lastUIUpdate = update;
  }

  @Mutation
  changeDeferred(deferred: Array<string>) {
    this.deferredUpdates = deferred;
  }
  @Mutation
  addDeferred(deferred: string) {
    this.deferredUpdates.push(deferred);
  }
  @Mutation
  changeCurrentMachine(update: MachineSWUpdateData | null) {
    this.currentMachineUpdate = update;
  }
  @Mutation
  changeUpdate(update: Array<MachineSWUpdateData>) {
    this.machineUpdates = update;
  }
  @Mutation
  addUpdate(update: MachineSWUpdateData) {
    if (this.machineUpdates.some((x) => x.machine_id == update.machine_id)) {
      const index = this.machineUpdates.findIndex((o) => o.machine_id == update.machine_id);
      this.machineUpdates.splice(index, 1, update);
    } else this.machineUpdates.push(update);
  }
}
